import axios from "axios";

// const { protocol } =  window.location;
const protocol = "https:";
const IBAS_URL = "auth.s2s.ph";
const CSP_URL = "csp.s2s.ph";
const BROKER_URL = "broker.s2s.ph";
const LOCATION_URL = "location.s2s.ph";
const PDS = "pds-api.s2s.ph";


export const API = axios.create({
  // baseURL:
  //   process.env.NODE_ENV === "development"
  //     ? "http://161.49.63.45:8089/api"
  //     : "http://161.49.61.43:8085/api",
  // baseURL: "http://reports.surf2sawa.com/api",
  baseURL: `${protocol}//` + IBAS_URL + `/api`,
  // baseURL: "http://161.49.63.45:8089/api",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 0,
});

export const CSP = axios.create({
  baseURL: `${protocol}//` + CSP_URL + `/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const DRS_API = axios.create({
  baseURL: `${protocol}//` + BROKER_URL + `/api`,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 0,
});

export const LOCATION_API = axios.create({
  baseURL: `${protocol}//` + LOCATION_URL + `/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const REPORTS = axios.create({
  baseURL: `${protocol}//` + IBAS_URL + `/api`,
  headers: {
    "Content-Type": "application/json",
  },
});
export const PDS_API = axios.create({
  baseURL: `${protocol}//` + PDS + `/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const DEV = axios.create({
  baseURL: "http://161.49.63.45:8089/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export const PAYMENT_API = axios.create({
  baseURL: "https://payment.s2s.ph/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export const ERROR_SERVICE_API = axios.create({
  baseURL: "https://ms-error-service.s2s.ph/api",
  headers: {
    "Content-Type": "application/json",
    "Authorization": "d1a4543504b34cf7b02ab5f5bba379c91713497063153"
  },
});


// https://ms-error-service.s2s.ph/api/app-error-logs

export const buildCount = "14";
export const versionCount = "1.0";
